import React from 'react';
import { Tag } from 'antd';
import { PackageType } from '../../../interfaces';

type IShowPackageTypeTag = {
    value?: PackageType;
};
export const ShowPackageTypeTag: React.FC<IShowPackageTypeTag> = ({ value }: IShowPackageTypeTag) => {
    return value ? (
        <Tag color={value === PackageType.ROAMING ? 'blue' : value === PackageType.LOCAL ? 'green' : 'orange'}>
            {value.toUpperCase()}
        </Tag>
    ) : null;
};
